/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because a year isn't a constant number of days — a calendar year is 365 days, but a leap year is 366, and the actual solar year is about 365.2422 days. Rather than pick one imprecise number, this tool treats 'year' as a calendar concept, not a fixed duration like an hour or day.`)
};

const es_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque un año no es un número constante de días — un año calendario es 365 días, pero un año bisiesto es 366, y el año solar real es aproximadamente 365.2422 días. En lugar de elegir un número impreciso, esta herramienta trata el 'año' como un concepto de calendario, no una duración fija como una hora o un día.`)
};

const de_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weil ein Jahr keine konstante Anzahl Tage hat — ein Kalenderjahr hat 365 Tage, ein Schaltjahr aber 366, und das tatsächliche Sonnenjahr sind etwa 365.2422 Tage. Statt eine ungenaue Zahl festzulegen, behandelt dieses Tool 'Jahr' als Kalenderkonzept, nicht als feste Dauer wie eine Stunde oder ein Tag.`)
};

const nl_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdat een jaar geen constant getal van dagen is — een kalenderjaar is 365 dagen, maar een schrikkeljaar is 366, en het werkelijke zonnegaar is ongeveer 365.2422 dagen. In plaats van één onnauwkeurig getal te kiezen, behandelt deze tool 'jaar' als een calendarconcept, niet een vaste duur zoals een uur of dag.`)
};

const fr_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parce qu'une année n'est pas un nombre constant de jours — une année calendaire est 365 jours, mais une année bissextile en est 366, et l'année solaire réelle est environ 365,2422 jours. Plutôt que de choisir un nombre imprécis, cet outil traite 'l'année' comme un concept calendaire, pas une durée fixe comme une heure ou un jour.`)
};

const it_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché un anno non è un numero costante di giorni — un anno di calendario è 365 giorni, ma un anno bisestile è 366, e l'anno solare effettivo è circa 365,2422 giorni. Piuttosto che scegliere un numero impreciso, questo strumento tratta 'anno' come un concetto di calendario, non una durata fissa come un'ora o un giorno.`)
};

const pt_br2_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque um ano não é um número constante de dias — um ano de calendário é 365 dias, mas um ano bissexto é 366, e o ano solar real é cerca de 365.2422 dias. Em vez de escolher um número impreciso, esta ferramenta trata 'ano' como um conceito de calendário, não uma duração fixa como uma hora ou dia.`)
};

const pt_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque um ano não é um número constante de dias — um ano de calendário é 365 dias, mas um ano bissexto é 366, e o ano solar real é cerca de 365,2422 dias. Em vez de escolher um número impreciso, esta ferramenta trata 'ano' como um conceito de calendário, não uma duração fixa como uma hora ou dia.`)
};

const ja_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年は一定の日数ではないため — カレンダー年は365日ですが、うるう年は366で、実際の太陽年は約365.2422日です。1つの不正確な数字を選ぶのではなく、このツールは「年」をカレンダーコンセプトとして扱い、時間またはその他の固定継続時間のような固定継続時間ではなく。`)
};

const zh_uc_time_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_time_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_time_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_time_faq2_a", locale)
	if (locale === "en") return en_uc_time_faq2_a(inputs)
	if (locale === "es") return es_uc_time_faq2_a(inputs)
	if (locale === "de") return de_uc_time_faq2_a(inputs)
	if (locale === "nl") return nl_uc_time_faq2_a(inputs)
	if (locale === "fr") return fr_uc_time_faq2_a(inputs)
	if (locale === "it") return it_uc_time_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_time_faq2_a(inputs)
	if (locale === "pt") return pt_uc_time_faq2_a(inputs)
	if (locale === "ja") return ja_uc_time_faq2_a(inputs)
	return zh_uc_time_faq2_a(inputs)
};